// extracted by mini-css-extract-plugin
export var centerText = "_5b-8";
export var container = "_5b-0";
export var doughnutContainer = "_5b-7";
export var legend = "_5b-a";
export var legendItemColorDisplay = "_5b-b";
export var legendItemLabel = "_5b-d";
export var legendItemValue = "_5b-c";
export var lg = "_5b-5";
export var maxWidth = "_5b-9";
export var md = "_5b-4";
export var responsive = "_5b-6";
export var sm = "_5b-3";
export var xs = "_5b-2";
export var xxs = "_5b-1";